export const PLATFORM_URLS = {
  CoreToken: "https://coretoken.net/",
  CoreBlockchain: "https://coreblockchain.net/",
};
